module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/125-finland-d794e106f7ab3898fd7579153f8a1fee.svg";